export enum Role {
  ROLE_DEPOT_ADMIN = 'ROLE_DEPOT_ADMIN',
  ROLE_DEPOT_ENGINEERING_ADMIN = 'ROLE_DEPOT_ENGINEERING_ADMIN',
  ROLE_DEPOT_ENGINEERING_USER = 'ROLE_DEPOT_ENGINEERING_USER',
  ROLE_DEPOT_MFG_ADMIN = 'ROLE_DEPOT_MFG_ADMIN',
  ROLE_DEPOT_MFG_USER = 'ROLE_DEPOT_MFG_USER',
  ROLE_DEPOT_OPS_ADMIN = 'ROLE_DEPOT_OPS_ADMIN',
  ROLE_DEPOT_OPS_USER = 'ROLE_DEPOT_OPS_USER',
  Portal_Admin = 'Portal-Admin',
  Portal_Business_Viewer = 'Portal-Business_Viewer',
  Portal_Commercial_Admin = 'Portal-Commercial_Admin',
  Portal_Commercial_CS = 'Portal-Commercial_CS',
  Portal_Commercial_Marketing = 'Portal-Commercial_Marketing',
  Portal_Ops_Admin = 'Portal-Ops_Admin',
  Portal_Ops_GroundTeam = 'Portal-Ops_GroundTeam',
  Portal_Ops_MC = 'Portal-Ops_MC',
  Portal_Ops_Support = 'Portal-Ops_Support',
  Portal_Dev_Admin = 'Portal-Dev_Admin',
  Portal_Ops_SIM = 'Portal_Ops_SIM',
  Portal_Flight_Testing = 'Portal-Flight_Testing',
  Portal_Pilot = 'Portal-Pilot'
}
